import { render, staticRenderFns } from "./IrrigationWaterSources.vue?vue&type=template&id=2e21b82c&scoped=true"
import script from "./IrrigationWaterSources.vue?vue&type=script&lang=js"
export * from "./IrrigationWaterSources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21b82c",
  null
  
)

export default component.exports